module.exports = __webpack_public_path__ + "media/images/survey-modal-9aeb8c6bd71e79a26e2f0f67da7d28b1.jpg";